<template>
  <k-editor-form>
    <template #left>
      <k-layout row>
        <k-flex c10>
          <k-text-field v-model="identifier" label="Identifier" autofocus @change="add_identifier"></k-text-field>
        </k-flex>
      </k-layout>

      <template v-for="(device,idx) in devices">
          <k-layout row>
              <k-flex c3>{{device.identifier}}</k-flex>
              <k-flex c3><k-chip size="xs">{{get_type_title(device.type)}}</k-chip></k-flex>
              <k-flex c4><k-chip size="xs">{{get_content_model(device.form_data.model, "name")}}</k-chip></k-flex>

              <k-flex c2>
                <k-btn flat size="xs" @click="del_identifier(idx)"><k-icon size="xs">delete</k-icon></k-btn>
              </k-flex>
          </k-layout>

      </template>

    </template>
    <template #right>
      <div v-if="device_type">
          <k-text-field label="Comment" v-model="comment"></k-text-field>
          <k-layout row>
            <k-flex c1><k-checkbox v-model="use_status_id"></k-checkbox></k-flex>
            <k-flex c11>
              <select-content-list :clearable="false" label="Status" :list_id="device_type.value.status_list_id" v-model="status_id" item-value="id" item-text="name"></select-content-list>
            </k-flex>
          </k-layout>
          <k-layout row>
            <k-flex c1><k-checkbox v-model="use_usage_id"></k-checkbox></k-flex>
            <k-flex c11>
              <select-content-list :clearable="false" label="Usage" :list_id="device_type.value.usage_list_id" v-model="usage_id" item-value="id" item-text="name"></select-content-list>
            </k-flex>
          </k-layout>
          <k-layout row>
            <k-flex c1><k-checkbox v-model="use_location_id"></k-checkbox></k-flex>
            <k-flex c11>
              <select-content-list :clearable="false" label="Location" :list_id="device_type.value.location_list_id" v-model="location_id" item-value="id" item-text="name"></select-content-list>
            </k-flex>
          </k-layout>
          <k-layout row>
            <k-flex c1><k-checkbox v-model="use_series_id"></k-checkbox></k-flex>
            <k-flex c11>
              <select-content-list :clearable="false" label="Series" :list_id="device_type.value.series_list_id" v-model="series_id" item-value="id" item-text="name"></select-content-list>
            </k-flex>
          </k-layout>
        </div>
        <k-layout row>
          <k-flex c6>
            <k-checkbox label="Update all subdevices" v-model="update_all_subdevices"></k-checkbox>
          </k-flex>
          <k-flex c6>
            <k-checkbox label="Remove all subdevices" v-model="remove_subdevices"></k-checkbox>
          </k-flex>
        </k-layout>
    </template>

    <template #right-buttons> 
      <k-btn size="m" color="success" @click="save(false)">Save</k-btn>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>

    </template>

  </k-editor-form>
</template>


<script>
import * as FormItems from '@/components/form_items'
import SettingsModel from '@/models/settings.js';
import SelectContentList from '@/components/SelectContentList'

export default {
  data () {
    var ch = this.$cloudserver.channel("devices:create");
    return {
      ws_channel: ch,
      identifier: "",
      devices: [],
      use_status_id: false,
      use_usage_id: false,
      use_location_id: false,
      use_series_id: false,
      status_id: undefined,
      location_id: undefined,
      series_id: undefined,
      usage_id: undefined,
      comment: "",
      remove_subdevices: false,
      update_all_subdevices: false
    }
  },
  components: {
    SelectContentList,
    ...FormItems
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
   device_type () {
    return SettingsModel.list("device_type")[0];
   }
  },

  methods: {
    get_type_title(type) {
      var setting = SettingsModel.get_by_name(type);
      if (typeof(setting) != "undefined") {
        return setting.title || type;
      }
      return type;
    },
    get_content_model(field, name) {
      if (typeof(field) != "undefined" && field != null) {
        return field[name];
      }
      return "";
    },
    add_identifier () {
      var self = this;
      var new_device = _.find(this.$store.state.devices, function(device) {
        return device.identifier == self.identifier;
      });
      if (typeof(new_device) != "undefined") {
        this.devices.push(new_device);
        this.identifier = "";
      }
    },
    del_identifier (idx) {
      var new_list = this.devices;
      new_list.splice(idx,1);
      this.devices = new_list;
    },
    get_device(id) {
      return this.$store.state.devices[id];
    },
    get_subdevices(parent_device) {
      var self = this;
      var device_list = [];
      _.each(parent_device.sub_device_list, function(id) {
        var device = self.get_device(id);
        device_list.push([device, self.get_subdevices(device)]);
      });
      return device_list;
    },

    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var device_log = {meta: {comment: self.comment}}

        var all_devices = self.devices;

        // tehdään muutokset myös kaikille alilaitteille
        if (self.update_all_subdevices == true) {
          var ndev = _.map(all_devices, function(device) {
            return _.flattenDeep(self.get_subdevices(device));
          });

          ndev = _.flatten(ndev);

          all_devices = all_devices.concat(ndev);
        }

        var devices = _.map(all_devices, function(device) {
          if (self.use_status_id == true) {device.status_id = self.status_id};
          if (self.use_location_id == true) {device.location_id = self.location_id};
          if (self.use_usage_id == true) {device.usage_id = self.usage_id};
          if (self.use_series_id == true) {device.series_id = self.series_id};
          return device;
        });

        _.each(devices, function(device) {
          var save_map = {device: device, device_log: device_log};

          if (self.remove_subdevices == true) {
            save_map["subdevices"] = [];
          }

          self.ws_channel.save(save_map)
          .then((msg) => {
            self.$message.success("Device was updated!");
            if (close) {
              self.$root.close_bottom_sheet();
            }
          })
          .catch((msg) => {
            console.log(msg);
            self.$message.warning("Unable to update device!");
          });          
        });

      }
    },
  }

}
</script>